import React from 'react';
import CellAbstract from './CellAbstract';
import { CELL_LINK_PROPS } from './Types';

class CellLink extends CellAbstract<CELL_LINK_PROPS, {}> {
  private getHostname = (href: string) => {
    const { cellConfig = {} } = this.props;
    const { noValidUrlName } = cellConfig;
    let hostnameByHref = noValidUrlName ? href : '';
    let hostname = '';
    try {
      ({ hostname } = new URL(href));
    } catch {
      // invalid URL string was passed to method
    }
    return hostname || hostnameByHref;
  };

  render() {
    const {
      dataIndex,
      dataItem,
      field,
      cellConfig
    } = this.props;

    const href = dataItem[(field || dataIndex)];
    const text = href ? this.getHostname(href) : '';
    const target = '_blank';

    return href === '' || href == undefined ? this.renderCell(<></>) : this.renderCell(
      <a
        className="tp-link"
        href={href}
        target={target}
      >
        {text}
      </a>
    );
  }
}

export default CellLink;
